import { render, staticRenderFns } from "./CustomerCharts.vue?vue&type=template&id=3ceba4c6"
import script from "./CustomerCharts.vue?vue&type=script&lang=js"
export * from "./CustomerCharts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports